import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class StaffService {

    static getStaff(item = {}) {
        let api = `${API_BASE_URL}${API_PATHS.getStaff}`;

        const params = new URLSearchParams();

        if (item?.id) {
            params.append("id", item.id);
        }

        if (item?.keyword) {
            params.append("keyword", item.keyword);
        }

        if (item?.page) {
            params.append("page", item.page);
        }

        if (item?.limit) {
            params.append("limit", item.limit);
        }

        if (params.toString()) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }
    static addStaff(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addStaff}`;
        return axiosInstance
            .post(api, data)

    }



    static editStaff(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editStaff}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteStaff(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteStaff}?id=${id}`;

        return axiosInstance
            .delete(api)
    }



}

export default StaffService;
